import React from 'react';
import PropTypes from 'prop-types';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { RX_FORM_TYPES } from '../../components/RxForm/constants';

const useStyles = makeStyles(theme => ({
  form: {
    width: '70%',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  option: {
    height: '100%'
  },
  description: {
    marginTop: theme.spacing(1)
  }
}));

const OPTIONS = [
  {
    type: RX_FORM_TYPES.IDB,
    title: 'Indirect Bonding',
    description: 'Start an indirect bonding case.'
  },
  {
    type: RX_FORM_TYPES.RETAINER,
    title: 'Retainers',
    description: 'Start a retainer case.'
  }
];

const CaseTypeSelection = ({ onSelect }) => {
  const classes = useStyles();

  return (
    <Card className={classes.form}>
      <CardHeader title="Start A Case" subheader="Choose the type of case to start." />
      <CardContent>
        <Grid container spacing={2}>
          {OPTIONS.map(option => (
            <Grid item xs={12} sm={6} key={option.type}>
              <Card variant="outlined" className={classes.option}>
                <CardActionArea onClick={() => onSelect(option.type)} className={classes.option}>
                  <CardContent>
                    <Typography variant="h6">{option.title}</Typography>
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      className={classes.description}
                    >
                      {option.description}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
};

CaseTypeSelection.propTypes = {
  onSelect: PropTypes.func.isRequired
};

export default CaseTypeSelection;
